import { OrderByDirection } from "constants/types";

export { OrderByDirection };

export interface IListParams<TOrder = any, TFilter = any> {
    page_token?: string;
    page_size?: number;
    order_by?: TOrder;
    order_by_direction?: OrderByDirection;
    filter?: TFilter;
    show_trashed?: boolean;
}

export interface TargetMousePosition {
    x: number;
    y: number;
}

export enum AssortmentType {
    Internal = "internal",
    External = "external",
    Vertical = "vertical",
}

export enum AssortmentTemplate {
    Standard = "Standard",
    Closeout = "Closeout",
}

export enum Capabilities {
    Assortments = "assortments",
    Whiteboards = "whiteboards",
}

export enum MemberKind {
    INVALID_MEMBER_TYPE = "INVALID_MEMBER_TYPE",
    USER = "USER",
}

export enum PermissionRole {
    Owner = "OWNER",
    Organizer = "ORGANIZER",
    FileOrganizer = "FILE_ORGANIZER",
    Writer = "WRITER",
    Commenter = "COMMENTER",
    Reader = "READER",
    InvalidRole = "INVALID_ROLE",
}
export const PermissionRanking = {
    [PermissionRole.Owner]: 7,
    [PermissionRole.Organizer]: 6,
    [PermissionRole.FileOrganizer]: 5,
    [PermissionRole.Writer]: 4,
    [PermissionRole.Commenter]: 3,
    [PermissionRole.Reader]: 2,
    [PermissionRole.InvalidRole]: 1,
};

export enum IdentityKind {
    InvalidIdentityKind = "INVALID_IDENTITY_KIND",
    Merchant = "MERCHANT",
    MerchantGroup = "MERCHANT_TEAM",
    MerchantMember = "MERCHANT_MEMBER",
}

export interface ILowerBoundaryRoleMap {
    [x: string]: string;
}

export enum ItemKind {
    Folder = "FOLDER",
    BoardDocument = "BOARD_DOCUMENT",
    CollectionDocument = "COLLECTION_DOCUMENT",
    CollectionRollupSnapshot = "COLLECTION_ROLLUP_SNAPSHOT",
    Shortcut = "SHORTCUT",
}

export enum SpaceItemOrderByField {
    CreateTime = "CREATE_TIME",
    DeleteTime = "DELETE_TIME",
    Name = "NAME",
    UpdateTime = "UPDATE_TIME",
}

export interface IOrderBy {
    field: SpaceItemOrderByField;
    direction: OrderByDirection;
}
